import type { Ref, MutableRefObject } from "react";

/** Takes multiple refs and returns a single ref-function that binds element instance to each ref */
export const combineRefs =
  <T>(...refs: Ref<T>[]): ((instance: T | null) => void) =>
  (component) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(component);
      }

      if (typeof ref === "object" && ref) {
        (ref as MutableRefObject<T | null>).current = component;
      }
    });
  };
